import z from 'zod';

export const attachmentItemSchema = z.object({
  sys: z.object({
    id: z.string(),
  }),
  fields: z.object({
    label: z.string(),
    downloadUrl: z.string().optional(),
    pdfUrl: z.string().optional(),
    pages: z.number().optional(),
  }),
});
